import React from 'react'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

/**
 * take any parameter and check if it's a React Element
 * @param child 
 * @returns 
 */
function isReactElement(child) {
    return React.isValidElement(child)
}

class IsotopeComponent extends React.Component {
    constructor(props) {
        super(props)
        this.filterKeys = props.filterKeys || []
        this.defaultPreview = props.defaultPreview
        this.children = props.children
        this.containerClassName = props.containerClassName
        this.isotopeNavigationClassName = props.isotopeNavigationClassName
        this.isotopeContainerRef = React.createRef()
        this.state = { filterKey: this.defaultPreview || "*" }
        this.setFilterKey = this.setFilterKey.bind(this)
        this.replaceSpaceByDash = this.replaceSpaceByDash.bind(this)
        this.timer = ""
    }

    replaceSpaceByDash = value => value.toLowerCase().replace(/ /g, '-')

    setFilterKey(filterKeyParam) {
        this.setState({ filterKey: this.replaceSpaceByDash(filterKeyParam) })
    }

    componentDidUpdate() {
        if (this.isotope) {
            this.state.filterKey === '*'
                ? this.isotope.arrange({ filter: '*' })
                : this.isotope.arrange({ filter: `.${this.state.filterKey}` })
        }
    }

    componentDidMount() {
        if (this.isotopeContainerRef.current) {
            imagesLoaded(this.isotopeContainerRef.current, () => {
                this.isotope = new Isotope('.filter-container', {
                    itemSelector: '.filter-item',
                    layoutMode: 'masonry',
                })
            })
        }
    }

    componentWillUnmount() {
        this.isotope && this.isotope.destroy()
    }

    render() {
        return (
            <>
                <ul  className={`nav font-sans-serif mb-3 ${this.isotopeNavigationClassName ?? ''}`}>
                    <li className="nav-item">
                        <a
                            className={`nav-link isotope-nav ${this.state.filterKey === '*' ? 'active' : ''}`}
                            href="#!"
                            onClick={() => this.setFilterKey('*')}
                        >all</a>
                    </li>
                    {this.filterKeys.length > 0 && this.filterKeys.map((el, key) => {
                        const hydrated = this.replaceSpaceByDash(el)
                        return (
                            <li key={`isotope-masonry-${key}`}>
                                <a
                                    className={`nav-link isotope-nav ${this.state.filterKey === hydrated ? 'active' : ''}`}
                                    href="#!"
                                    onClick={() => this.setFilterKey(hydrated)}
                                >{el}</a>
                            </li>
                        )
                    })}
                </ul>
                <div ref={this.isotopeContainerRef} className={`${this.containerClassName ?? ''} filter-container`}>
                    {React.Children.map(this.children, (child, key) => {
                        if (child && isReactElement(child)) {
                            const newProps = {
                                className: `${child.props.className ?? ''} filter-item`,
                                key: key
                            }
                            return React.cloneElement(child, newProps);
                        }
                        return child
                    })}
                </div>
            </>
        )
    }
}

export default IsotopeComponent